import { render, staticRenderFns } from "./ActionsComponent.vue?vue&type=template&id=1348fa6a&scoped=true&"
import script from "./ActionsComponent.vue?vue&type=script&lang=js&"
export * from "./ActionsComponent.vue?vue&type=script&lang=js&"
import style0 from "./ActionsComponent.vue?vue&type=style&index=0&id=1348fa6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1348fa6a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCol,VImg,VRow})
